import { Select } from 'antd';
import React from 'react';
import Storage from './../../services/Storage';
import { checkPaymentTerms } from '../../reducers/helper/helperFunctions';
import { terms as originalTerms, newTerms } from './../../constants';
import { ListChannel as Channels} from '../../constants/setting_channel';
import { destinationCountries } from './../../services/constant'

const Option = Select.Option

export const renderRowCurrency = () => {
    let listCurrency = Storage.get('currencies')
    let listCurrencyNew = []

    if (!listCurrency) return

    for (let i = 0; i < listCurrency.length; i++) {
        if (listCurrency[i].CurrencyCode === "JPY") {
            listCurrencyNew[0] = listCurrency[i]
        } else if (listCurrency[i].CurrencyCode === "USD") {
            listCurrencyNew[1] = listCurrency[i]
        } else if (listCurrency[i].CurrencyCode === "CAD") {
            listCurrencyNew[2] = listCurrency[i]
        } else {
            listCurrencyNew[3 + i] = listCurrency[i]
        }
    }

    return listCurrencyNew.map((value, key) => (
        <Option key={key} value={value.CurrencyCode}>{value.CurrencyCode}</Option>
    ))
}

export const renderIterms = (terms) => {
    let itermsNew = []
    let arrKey = Object.keys(terms)
    if (!terms) return

    for (let i = 0; i < arrKey.length; i++) {
        itermsNew.push(<Option key={i} value={arrKey[i]}>{terms[arrKey[i]]}</Option>)
    }

    return itermsNew
}

export const renderDestinationCountries = (availableCountries, channel_short_name) => {
    let options = []
    let shipperDestinationCountries = String(availableCountries).split(',')
    let countries = shipperDestinationCountries
    if(channel_short_name != Channels.Y_SHIP.ShortName){
        countries = countries.filter(country => country == 'JP')
    }
    for(let i = 0; i < countries.length; i++){
        let countryCode = countries[i]
        destinationCountries.map(country => {
            if(country.key == countryCode){
                options.push(<Option value={countryCode} key={countryCode.key}>{country.value}</Option>)
            }
        })
    }
    return options
}
export const renderPaymentTerms = (paymentTerms, defaultPaymentTerm, channel_short_name, country) => {
    let arrPaymentTerms = String(paymentTerms).trim().split(",").filter(paymentType => checkPaymentTerms(paymentType));
    let originalTermsList = Object.keys(originalTerms);
    if (channel_short_name == Channels.Y_SHIP.ShortName) {
        if (!arrPaymentTerms.length)
        {
          arrPaymentTerms = originalTermsList;
        }
        if(checkPaymentTerms(defaultPaymentTerm) && !arrPaymentTerms.includes(defaultPaymentTerm))
        {
          arrPaymentTerms.push(defaultPaymentTerm);
        }
    }
    else {
        arrPaymentTerms = originalTermsList;
    }
    // If Destination Country is not JP, only Payment Term 2 and 3 are available.
    if(country != 'JP'){
        arrPaymentTerms = arrPaymentTerms.filter(term => originalTermsList.includes(term))
    }
    if(arrPaymentTerms.length > 0)
    {
        arrPaymentTerms.sort();
        return arrPaymentTerms.filter(paymentType => checkPaymentTerms(paymentType)).map((paymentType, i) =>
            <Option key={i} value={paymentType}>{newTerms[paymentType]}</Option>);
    }
    else
    {
        return;
    }
}

export const renderPreferredTime = (preferredTime) => {
    let listPreferredTime = [];
    let keys = Object.keys(preferredTime).sort();

    // move AM to positon index 1
    if (keys.indexOf("AM") > -1) {
        keys = keys.filter((i) => {
            return i != 'AM';
        });
        keys.splice(1, 0, 'AM');
    }
    keys.forEach(elm => {
        listPreferredTime.push(<Option key={elm} value={elm}>{preferredTime[elm]}</Option>)
    });
    return listPreferredTime
}

export const renderRowCountry = () => {
    let listCountry = Storage.get('countries')

    if (!listCountry) return

    return listCountry.map((item, key) => {
        return (
            <Option key={key} value={item.CountryCode}>{item.Description}</Option>
        )
    })
}
export const getCountry = (information, shipperCountries) => {
    let shipperCountryArray = String(shipperCountries).split(",")

    if(!information.country){
        if(information.channel_short_name != Channels.Y_SHIP.ShortName){
            shipperCountryArray = shipperCountryArray.filter(x => x == 'JP')
        }
        return shipperCountryArray.length > 0 ? shipperCountryArray[0] : ""
    }
    return information.country
}



// WEBPACK FOOTER //
// ./src/components/render-select/index.js